<form [formGroup]="form" class="cdp-cron-editor">
    <h4>
        Repeats
        <ng-select
            class="freq-selector"
            [items]="frequencies"
            placeholder="Select interval"
            [clearable]="false"
            [searchable]="false"
            [(ngModel)]="form.value.frequencyId"
            formControlName="frequencyId"
            appendTo=".auto-width-ng-select"
            bindValue="id"
        >
            <ng-template ng-option-tmp let-item="item">
                <div class="opt-row" [title]="item.helpText">
                    <span class="freq-name">{{ item.name }}</span>
                    <span class="freq-desc">{{ item.description }}</span>
                </div>
            </ng-template>
            <ng-template ng-label-tmp let-item="item" let-clear="clear">
                <span class="freq-name" [title]="item.helpText">{{ item.name }}</span>
            </ng-template>
        </ng-select>
    </h4>
    <div class="container">
        <div class="cdp-cron-form">
            <!-- Every 1 hour/minute/day/month -->
            <hc-form-field
                [inline]="true"
                *ngIf="form.value.frequencyId !== frequencyIds.week && form.value.frequencyId !== frequencyIds.custom"
            >
                <hc-label>Every</hc-label>

                <hc-select class="cdp-cron-select-field-md" formControlName="frequency">
                    <option *ngFor="let frequency of frequencyRange; let i = index" [ngValue]="(i + 1).toString()">
                        {{ i + 1 }}
                    </option>
                </hc-select>
            </hc-form-field>

            <!-- Every week/hour/minute-->
            <hc-form-field [inline]="true" *ngIf="form.value.frequencyId !== frequencyIds.custom">
                <hc-label>{{ form.value.frequencyId === frequencyIds.week ? 'Every' : '' }}&nbsp; </hc-label>
                <hc-select
                    placeholder="Choose cadence ..."
                    formControlName="frequencyId"
                    class="cdp-cron-select-field-lg"
                    [ngModel]="form.value.frequencyId"
                >
                    <option *ngFor="let frequency of frequencies" [value]="frequency.id">
                        {{ frequency.displayType }}
                    </option>
                </hc-select>
            </hc-form-field>

            <!-- month .. on the 1st-->
            <ng-container *ngIf="form.value.frequencyId === frequencyIds.month">
                <label class="cdp-cron-label">on the</label>
                <ng-select
                    formControlName="daysOfMonth"
                    placeholder="Select day(s)"
                    [closeOnSelect]="false"
                    [clearable]="false"
                    [multiple]="true"
                    [searchable]="false"
                    [items]="dayOfMonthOptions"
                    bindValue="value"
                    appendTo=".auto-width-ng-select"
                >
                    <ng-template ng-multi-label-tmp let-items="items">
                        {{ displayDaysOfMonth(items) }}
                    </ng-template>
                    <ng-template ng-option-tmp let-item="item" let-item$="item$" let-index="index">
                        <span class="ng-slim-option">
                            <hc-checkbox [checked]="item$.selected" [isStub]="true" [tight]="true">
                                {{ item.label }}
                            </hc-checkbox>
                        </span>
                    </ng-template>
                    <ng-template ng-header-tmp>
                        <div class="ng-select-header">
                            <button hc-button buttonStyle="link-inline" size="sm" (click)="selectAllDaysOfMonth()">
                                Select all
                            </button>
                            <button hc-button buttonStyle="link-inline" size="sm" (click)="unselectAllDaysOfMonth()">
                                Clear all
                            </button>
                        </div>
                    </ng-template>
                </ng-select>
            </ng-container>

            <!-- on Saturday -->
            <ng-container *ngIf="form.value.frequencyId === frequencyIds.week">
                <label class="cdp-cron-label">on</label>
                <ng-select
                    formControlName="daysOfWeek"
                    placeholder="Select day(s)"
                    [closeOnSelect]="false"
                    [clearable]="false"
                    [multiple]="true"
                    [searchable]="false"
                    [items]="dayOfWeekOptions"
                    appendTo=".auto-width-ng-select"
                >
                    <ng-template ng-multi-label-tmp let-items="items">
                        {{ joinDaysOfWeek(items) }}
                    </ng-template>
                    <ng-template ng-option-tmp let-item="item" let-item$="item$" let-index="index">
                        <span class="ng-slim-option">
                            <hc-checkbox [checked]="item$.selected" [isStub]="true" [tight]="true">
                                {{ item }}
                            </hc-checkbox>
                        </span>
                    </ng-template>
                    <ng-template ng-header-tmp>
                        <div class="ng-select-header">
                            <button hc-button buttonStyle="link-inline" size="sm" (click)="selectAllDaysOfWeek()">
                                Select all
                            </button>
                            <button hc-button buttonStyle="link-inline" size="sm" (click)="unselectAllDaysOfWeek()">
                                Clear all
                            </button>
                        </div>
                    </ng-template>
                </ng-select>
            </ng-container>

            <!-- at minutes past the hour -->
            <ng-container *ngIf="form.value.frequencyId === frequencyIds.hour">
                <hc-form-field [inline]="true">
                    <hc-label class="cdp-cron-label">at</hc-label>
                    <hc-select class="cdp-cron-select-field-xsm" formControlName="minute">
                        <option *ngFor="let minute of minuteRange; let i = index" [ngValue]="i.toString()">
                            {{ i | number: '2.0' }}
                        </option>
                    </hc-select>
                </hc-form-field>
                <span class="cdp-cron-label">minutes past the hour</span>
            </ng-container>

            <!-- at 3:00 am -->
            <ng-container
                *ngIf="[frequencyIds.day, frequencyIds.month, frequencyIds.week].indexOf(form.value.frequencyId) >= 0"
            >
                <hc-form-field [inline]="true">
                    <hc-label class="cdp-cron-label">at</hc-label>
                    <hc-select class="cdp-cron-select-field-xsm" formControlName="hour">
                        <option *ngFor="let hour of hourRange; let i = index" [ngValue]="(i + 1).toString()">
                            {{ i + 1 | number: '2.0' }}
                        </option>
                    </hc-select>
                </hc-form-field>

                <hc-form-field [inline]="true">
                    <hc-label class="cdp-cron-label">:</hc-label>
                    <hc-select class="cdp-cron-select-field-xsm" formControlName="minute">
                        <option *ngFor="let minute of minuteRange; let i = index" [ngValue]="i.toString()">
                            {{ i | number: '2.0' }}
                        </option>
                    </hc-select>
                </hc-form-field>

                <hc-form-field [inline]="true">
                    <hc-label>&nbsp;</hc-label>
                    <hc-select placeholder="Select ..." class="cdp-cron-select-field-sm" formControlName="meridian">
                        <option value="{{ meridians.am }}">AM</option>
                        <option value="{{ meridians.pm }}">PM</option>
                    </hc-select>
                </hc-form-field>
            </ng-container>

            <!-- custom-->
            <div *ngIf="form.value.frequencyId === frequencyIds.custom" class="raw-cron-container">
                <div class="raw-cron-container-inner">
                    <hc-form-field class="raw-cron-form-field">
                        <hc-label class="raw-cron-label">
                            Raw cron expression
                            <a
                                class="cdp-cron-link"
                                href="https://www.ibm.com/docs/en/db2oc?topic=task-unix-cron-format"
                                target="_blank"
                                title="Learn how to write cron expressions"
                            >
                                Learn cron<span class="icon-external-link icon-right"></span>
                            </a>
                        </hc-label>

                        <input hcInput autocomplete="off" formControlName="rawCron" />
                    </hc-form-field>

                    <div class="cron-map">
                        <div class="cron-map-col">
                            <div class="cron-map-col-star"><span>*</span></div>
                            <div class="cron-map-col-name">minute</div>
                            <div class="cron-map-col-options">0-59</div>
                        </div>
                        <div class="cron-map-col">
                            <div class="cron-map-col-star"><span>*</span></div>
                            <div class="cron-map-col-name">hour</div>
                            <div class="cron-map-col-options">0-23</div>
                        </div>
                        <div class="cron-map-col">
                            <div class="cron-map-col-star"><span>*</span></div>
                            <div class="cron-map-col-name">day of month</div>
                            <div class="cron-map-col-options">1-31</div>
                        </div>
                        <div class="cron-map-col">
                            <div class="cron-map-col-star"><span>*</span></div>
                            <div class="cron-map-col-name">month</div>
                            <div class="cron-map-col-options">1-12</div>
                        </div>
                        <div class="cron-map-col">
                            <div class="cron-map-col-star"><span>*</span></div>
                            <div class="cron-map-col-name">day of week</div>
                            <div class="cron-map-col-options">1-7</div>
                        </div>
                    </div>
                </div>
                <div class="raw-cron-legend">
                    <h4>Available special characters</h4>
                    <table class="hc-table hc-table-small">
                        <tbody>
                            <tr>
                                <th><span class="raw-cron-legend-item">*</span></th>
                                <td>
                                    <div>
                                        All possible values
                                        <span
                                            class="icon-info cdp-info-ico"
                                            [hcPop]="cronStarHelp"
                                            trigger="hover"
                                        ></span>
                                    </div>
                                </td>
                            </tr>
                            <tr>
                                <th><span class="raw-cron-legend-item">-</span></th>
                                <td>
                                    <div>
                                        Range of values
                                        <span
                                            class="icon-info cdp-info-ico"
                                            [hcPop]="cronDashHelp"
                                            trigger="hover"
                                        ></span>
                                    </div>
                                </td>
                            </tr>
                            <tr>
                                <th><span class="raw-cron-legend-item">,</span></th>
                                <td>
                                    <div>
                                        List of values
                                        <span
                                            class="icon-info cdp-info-ico"
                                            [hcPop]="cronCommaHelp"
                                            trigger="hover"
                                        ></span>
                                    </div>
                                </td>
                            </tr>
                            <tr>
                                <th><span class="raw-cron-legend-item raw-cron-legend-item-character">/</span></th>
                                <td>
                                    <div>
                                        Skip # of values
                                        <span
                                            class="icon-info cdp-info-ico"
                                            [hcPop]="cronSkipHelp"
                                            trigger="hover"
                                        ></span>
                                    </div>
                                </td>
                            </tr>
                            <tr>
                                <th><span class="raw-cron-legend-item raw-cron-legend-item-character">L</span></th>
                                <td>
                                    <div>
                                        Last day of month<span
                                            class="icon-info cdp-info-ico"
                                            [hcPop]="cronLastHelp"
                                            trigger="hover"
                                        ></span>
                                    </div>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
            <!-- end custom -->
        </div>
    </div>
    <span class="plain-english-cron">{{ cronDisplayText }}</span>
</form>

<hc-pop #cronStarHelp [disableStyle]="true">
    <div class="hc-tooltip">
        <div class="cron-help-title">Example</div>
        <div class="cron-help-detail">Column 1, minute</div>
        <div class="cron-help-example">* = Every minute</div>
    </div>
</hc-pop>
<hc-pop #cronDashHelp [disableStyle]="true">
    <div class="hc-tooltip">
        <div class="cron-help-title">Example</div>
        <div class="cron-help-detail">Column 5, day of week</div>
        <div class="cron-help-example">2-4 = Tuesday through Thursday</div>
    </div>
</hc-pop>
<hc-pop #cronCommaHelp [disableStyle]="true">
    <div class="hc-tooltip">
        <div class="cron-help-title">Example</div>
        <div class="cron-help-detail">Column 5, day of week</div>
        <div class="cron-help-example">1,3,7 = Monday, Wednesday, Saturday</div>
    </div>
</hc-pop>
<hc-pop #cronSkipHelp [disableStyle]="true">
    <div class="hc-tooltip">
        <div class="cron-help-title">Example</div>
        <div class="cron-help-detail">Column 3, day of month</div>
        <div class="cron-help-example">*/3 = Every 3 days</div>
    </div>
</hc-pop>
<hc-pop #cronLastHelp [disableStyle]="true">
    <div class="hc-tooltip">
        <div class="cron-help-title">Example</div>
        <div class="cron-help-detail">Column 3, day of month</div>
        <div class="cron-help-example">
            L = 28th, 30th, or 31st
            <span class="cron-help-detail">(Depending on the month)</span>
        </div>
    </div>
</hc-pop>
